module.exports = __webpack_public_path__ + "static/img/about-banner.034920a0.jpg";